export const triggerHeatMap = name => {
  window.hj =
    window.hj ||
    // eslint-disable-next-line func-names
    function(...args) {
      (hj.q = hj.q || []).push(...args);
    };
  hj('trigger', name);
};
